import { render, staticRenderFns } from "./add.vue?vue&type=template&id=f618e3c2&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=f618e3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f618e3c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f618e3c2')) {
      api.createRecord('f618e3c2', component.options)
    } else {
      api.reload('f618e3c2', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=f618e3c2&scoped=true&", function () {
      api.rerender('f618e3c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/patch-voltager/add.vue"
export default component.exports